import { render } from "./QualifiersTab.vue?vue&type=template&id=36a3d0c9"
import script from "./QualifiersTab.vue?vue&type=script&lang=js"
export * from "./QualifiersTab.vue?vue&type=script&lang=js"

import "./QualifiersTab.vue?vue&type=style&index=0&id=36a3d0c9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__